<script setup lang="ts">
import { Direction } from '@enums/direction';
import Tooltip from '@components/Tooltip.vue';

const props = withDefaults(defineProps<{
  panelClass?: string,
}>(), {
  panelClass: '',
});
</script>

<template>
  <Tooltip
    :direction="Direction.RIGHT"
    class="vertical-menu-tooltip"
    :panel-class="`vertical-menu-tooltip__panel ${panelClass}`"
    trigger-class="vertical-menu-tooltip__sidebar"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>

    <template #panel>
      <slot name="panel" />
    </template>
  </Tooltip>
</template>
